import { createIcon } from "@chakra-ui/react";

export const ArrowLeft = createIcon({
  displayName: "ArrowLeft",
  viewBox: "0 0 24 24",
  d: "M2.44 13.06a1.502 1.502 0 0 1 0-2.124l7.5-7.5a1.502 1.502 0 0 1 2.123 2.123L7.118 10.5h14.381c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H7.122l4.936 4.94a1.502 1.502 0 0 1-2.123 2.124l-7.5-7.5.005-.005z",
  defaultProps: {
    "aria-label": "An arrow pointing left"
  }
});

export default ArrowLeft;
